import styled from 'styled-components';

export const WorkingStatus = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: var(--black-200);
  border-radius: 0.3rem;
  margin-top: 1rem;

  &.skeleton {
    padding: 0;
    background: transparent;
  }

  &.available {
    color: var(--primary);
    background: var(--darker-primary);
    justify-content: center;
  }
`

export const Info = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  &.skeleton {
    width: 100%;
  }

  svg {
    width: 2rem;
    height: 2rem;
    padding: 0.5rem;
    background: var(--black-100);
    border-radius: 4px;
  }
`

export const Description = styled.div`
  margin-left: 0.5rem;

  p {
    font-size: 14px;
    color: var(--white);
    margin: 0;
    width: auto;
    max-width: 210px;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 1.2rem;
    text-overflow: ellipsis;
  }

  &.available {
    p {
      color: var(--primary);
    }
  }
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background-color: var(--primary);
  border-radius: 4px;
  
  svg {
    width: 1rem;
    height: 1rem;
  }
`

export const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  margin-top: 0.5rem;
  background: var(--black-200);
  border-radius: 4px;
  font-family: IBM Plex Sans;
  color: var(--primary);
  background: var(--darker-primary);

  &.skeleton {
    background: transparent;
    padding: 0;
  }
`